module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-9-min.16d16328.jpg";